import { EMPTY_LIST, NOTIFICATION_TYPE } from '../../../../constants/common'
import { APPLICANT_STAGE } from '../../../RentalPortalApplicant'
import { getIsApplicantClosed } from '../RentalPortalApplicantProfile.utils'

import { APPLICANT_PROFILE_BLOCK_CONFLICT_NOTIFICATION_ID } from './RentalPortalApplicantProfileTabOverview.constants'

export function getCanEditApplicantBlock(applicantData) {
  return Boolean(
    !getIsApplicantClosed(applicantData) && applicantData?.permissions?.can_edit
  )
}

export function getIsApplicantWidgetSkeleton({ applicantData, isInitiated }) {
  return !isInitiated || !applicantData
}

export function getIsApplicantIdentityFrozen(applicantData) {
  return Boolean(applicantData?.selected_at)
}

export function getIsApplicantPoolStage(applicantData) {
  return applicantData?.stage === APPLICANT_STAGE.pool
}

export function getHasApplicantScreeningBlocks(applicantData) {
  return (
    Boolean(applicantData?.stage) && !getIsApplicantPoolStage(applicantData)
  )
}

export function getApplicantTransition({ applicantData, key }) {
  return (applicantData?.available_transitions ?? EMPTY_LIST).find(
    transition => transition.key === key
  )
}

export function getIsApplicantTerminalStage(applicantData) {
  return Boolean(
    applicantData?.phase?.is_terminal ||
    applicantData?.terminal_at ||
    applicantData?.archived
  )
}

export function getApplicantBlockConflictNotification({
  t,
  onClickOverwrite,
  onClickReload,
}) {
  return {
    actions: [
      {
        callback: onClickReload,
        text: t('RentalPortal.ApplicantProfileBlockConflictReloadBtnKey'),
      },
      {
        callback: onClickOverwrite,
        text: t('RentalPortal.ApplicantProfileBlockConflictOverwriteBtnKey'),
      },
    ],
    id: APPLICANT_PROFILE_BLOCK_CONFLICT_NOTIFICATION_ID,
    text: t('RentalPortal.ApplicantProfileBlockConflictKey'),
    type: NOTIFICATION_TYPE.warning,
  }
}
